var exports = {
  "kL": "xa15a2ab7--53abdc--container",
  "G_": "xa15a2ab7--53abdc--disable-external-container-styles",
  "v": "xa15a2ab7--53abdc--title_block",
};

module.exports = exports;
